import { render, staticRenderFns } from "./orderReportBox.vue?vue&type=template&id=79814bbe&scoped=true"
import script from "./orderReportBox.vue?vue&type=script&lang=js"
export * from "./orderReportBox.vue?vue&type=script&lang=js"
import style0 from "./orderReportBox.vue?vue&type=style&index=0&id=79814bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79814bbe",
  null
  
)

export default component.exports